<script lang="ts">
	import PageHero from "@components/PageHero.svelte";
	import Layout from "@components/layout/Layout.svelte";
	import type { PrivacyPolicyProps } from "./PrivacyPolicyProps.js";

	const _: PrivacyPolicyProps = $props();
</script>

<Layout>
	<PageHero headline="Ochrana osobních údajů" description="" highlightedDescription="" />
	<section class="grid-container full-width bg-gradient-to-t from-light/50 to-light lg:pt-20 pb-10 pt-12 lg:pb-1">
		<div class="mb-3 w-full lg:mb-5 lg:w-[50rem]">
			<h2 class="text-xl">Shromažďované informace a&nbsp;jejich využití</h2>
		</div>
		<div class="lg:w-[50rem]">
			<p class="mb-3 lg:mb-[0.95rem] lg:leading-[1.4rem]">
				Využití webu a&nbsp;formuláře na webu <a href="https://www.intimex.cz">www.intimex.cz</a> může být ze strany Provozovatele
				podmíněn poskytnutím některých osobních údajů Uživatele ve smyslu zák. č.&nbsp;110/2019 Sb., o&nbsp;ochraně osobních
				údajů a&nbsp;případně i&nbsp;jiných zákonů, v&nbsp;platném znění. V&nbsp;takovém případě bude Provozovatel s&nbsp;těmito
				údaji nakládat v&nbsp;souladu s&nbsp;platnými právními předpisy.
			</p>
		</div>
		<div class="mb-3 w-full lg:mb-5 lg:w-[50rem]">
			<h2 class="text-xl mt-4 lg:mt-8">Předávání osobních údajů</h2>
		</div>
		<div class="lg:w-[50rem]">
			<p class="mb-3 lg:mb-[0.95rem] lg:leading-[1.4rem]">
				Provozovatel spolupracuje se společnostmi, které mu poskytují různé služby. Tyto společnosti, pokud jsou
				k&nbsp;tomu oprávněné, mohou nakládat s&nbsp;osobními údaji Uživatele, přičemž s&nbsp;těmito informacemi pracují
				pouze při plnění svých povinností a&nbsp;nesmí je použít k&nbsp;jinému účelu. Provozovatel neprodává, nepřevádí
				a&nbsp;nesděluje osobní údaje třetím stranám.
			</p>
			<p class="mb-3 lg:mb-[0.95rem] lg:leading-[1.4rem]">
				Provozovatel si však vyhrazuje právo použít nebo předat jakýkoli údaj, který bude potřebný k&nbsp;naplnění
				právních předpisů, k&nbsp;ochraně integrity sítě, ke splnění požadavku Uživatele nebo při soudním vyšetřování
				a&nbsp;vyšetřování ve veřejném zájmu.
			</p>
			<p class="mb-3 lg:mb-[0.95rem] lg:leading-[1.4rem]">
				Pokud si Uživatel přeje opravit osobní data, které o&nbsp;něm Provozovatel má, může jej o&nbsp;to požádat na
				emailové adrese <a href="mailto:intimex@post.cz">intimex@post.cz</a> nebo na poštovní adrese uvedené na stránce Kontakty.
			</p>
		</div>
		<div class="mb-3 w-full lg:mb-5 lg:w-[50rem]">
			<h2 class="text-xl mt-4 lg:mt-8">Kódy třetích stran</h2>
		</div>
		<div class="lg:w-[50rem]">
			<p class="mb-3 lg:mb-[0.95rem] lg:leading-[1.4rem]">
				Na tomto webu používáme kódy od společností Google, které nám pomáhají analyzovat chování návštěvníků webu.
			</p>
		</div>
		<div class="mb-3 w-full lg:mb-5 lg:w-[50rem]">
			<h2 class="text-xl mt-4 lg:mt-8">Google Analytics</h2>
		</div>
		<div class="lg:w-[50rem]">
			<p class="mb-3 lg:mb-[0.95rem] lg:leading-[1.4rem]">
				Tyto stránky využívají službu Google Analytics, poskytovanou společností Google, Inc. (dále jen „Google“).
				Služba Google Analytics používá souborů „cookies“, které jsou textovými soubory ukládanými do vašeho počítače,
				umožňující analýzu způsobu užívání této stránky jejími uživateli. Informace vygenerované souborem cookie
				o&nbsp;užívání stránky (včetně vaší IP adresy) budou společností Google přeneseny a&nbsp;uloženy na serverech ve
				Spojených státech.
			</p>
			<p class="mb-3 lg:mb-[0.95rem] lg:leading-[1.4rem]">
				Google bude užívat tyto informace pro účely vyhododnocování užívání stránky a&nbsp;vytváření zpráv o&nbsp;její
				aktivitě, určených pro její provozovatele, a&nbsp;pro poskytování dalších služeb týkajících se činností na
				stránce a&nbsp;užívání internetu vůbec. Google může také poskytnout tyto informace třetím osobám, bude-li to
				požadováno zákonem nebo budou-li takovéto třetí osoby zpracovávat tyto informace pro Google. Google nebude
				spojovat vaši IP adresu s&nbsp;jakýmikoli jinými daty, která má k&nbsp;dispozici. Můžete odmítnout používání
				souborů cookies volbou v&nbsp;příslušném nastavení ve vašem prohlížeči, avšak uvědomte si, že jestliže tak
				učiníte, nebudete schopni plně využívat veškeré funkce této stránky. Používáním této stránky souhlasíte se
				zpracováváním údajů o&nbsp;vás společností Google, a&nbsp;to způsobem a&nbsp;k&nbsp;účelu shora uvedeným.
			</p>
			<p class="mb-3 lg:mb-[0.95rem] lg:leading-[1.4rem]">
				Detailní informace o&nbsp;Google Analytics a&nbsp;ochraně osobních údajů naleznete na <a
					href="http://www.google.com/intl/cz/privacy/privacy-policy.html"
					target="_blank"
					>policies.google.com/privacy
				</a>.
			</p>
		</div>
		<div class="mb-3 w-full lg:mb-5 lg:w-[50rem]">
			<h2 class="text-xl mt-4 lg:mt-8">Cookies</h2>
		</div>
		<div class="lg:w-[50rem]">
			<p class="mb-3 lg:mb-[0.95rem] lg:leading-[1.4rem]">
				„Cookies“ jsou informace, které jsou z&nbsp;internetové stránky převáděny na hard disk počítače Uživatele.
				Cookies umožňují internetové stránce zapamatovat si důležité informace, které Uživateli ulehčí další její
				používání. Jako většina internetových stránek, i&nbsp;stránky Provozovatele používají cookies. Na základě
				anonymních datových objektů například Provozovatel sleduje celkový počet návštěvníků na těchto stránkách. Pokud
				nechce Uživatel cookies používat nebo pokud chce, aby internetový prohlížeč použití cookies oznámil, musí tento
				ve svém internetovém prohlížeči vybrat příslušnou volbu. Zablokuje-li Uživatel všechna cookies, nebude moci
				využít některé funkce těchto stránek.
			</p>
		</div>
		<div class="mb-3 w-full lg:mb-5 lg:w-[50rem]">
			<h2 class="text-xl mt-4 lg:mt-8">Změny v&nbsp;politice ochrany osobních dat</h2>
		</div>
		<div class="lg:w-[50rem]">
			<p class="mb-3 lg:mb-[0.95rem] lg:leading-[1.4rem]">
				Provozovatel si vyhrazuje právo jakkoliv a&nbsp;kdykoliv měnit svoji politiku ochrany osobních dat, přičemž
				aktuální stav bude vždy umístněn na těchto stránkách.
			</p>
		</div>
		<div class="mb-3 w-full lg:mb-5 lg:w-[50rem]">
			<h2 class="text-xl mt-4 lg:mt-8">Chování uživatelů</h2>
		</div>
		<div class="lg:w-[50rem]">
			<p class="mb-3 lg:mb-[0.95rem] lg:leading-[1.4rem]">
				Při používání těchto stránek Uživatel nesmí zasahovat do bezpečnosti těchto stránek, nemůže tyto stránky
				využívat k&nbsp;přenášení škodlivých souborů a&nbsp;snažit se proniknout do veřejně nepřístupných míst těchto
				stránek. Uživatel je rovněž povinen ctít autorská práva Provozovatele k&nbsp;těmto stránkám.
			</p>
		</div>
		<div class="mb-3 w-full lg:mb-5 lg:w-[50rem]">
			<h2 class="text-xl mt-4 lg:mt-8">Odpovědnost a&nbsp;právní příslušnost</h2>
		</div>
		<div class="lg:w-[50rem]">
			<p class="mb-3 lg:mb-[0.95rem] lg:leading-[1.4rem]">
				Případná rizika plynoucí Uživateli z&nbsp;používání těchto stránek, jsou zcela na Uživateli a&nbsp;Provozovatel
				za ně nenese jakoukoliv odpovědnost. Veškeré spory vzniklé v&nbsp;souvislosti s&nbsp;využíváním těchto stránek,
				budou projednávány místně příslušným soudem v&nbsp;České republice a&nbsp;v&nbsp;souladu se zákony České
				republiky. Ustanovení těchto podmínek, které se z&nbsp;jakéhokoliv důvodu stanou nevymahatelné, budou považována
				za oddělitelná od zbývajících ujednání a&nbsp;na jejich platnost a&nbsp;vymahatelnost nebudou mít vliv. Veškeré
				údaje, uvedené na těchto stránkách včetně použitého obrazového materiálu mají nezávazný informativní charakter
				a&nbsp;tyto nelze vykládat jako nabídku na uzavření smlouvy, ani jako vymahatelné smluvní podmínky. Závazné
				informace budou klientovi předloženy vždy v&nbsp;rámci konkrétní obchodní a&nbsp;smluvní dokumentace.
			</p>
		</div>
	</section>
</Layout>
